import { render, staticRenderFns } from "./ReportIssue.vue?vue&type=template&id=ff4041e8&scoped=true"
import script from "./ReportIssue.vue?vue&type=script&lang=js"
export * from "./ReportIssue.vue?vue&type=script&lang=js"
import style0 from "./ReportIssue.vue?vue&type=style&index=0&id=ff4041e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4041e8",
  null
  
)

export default component.exports